import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { AuthService } from 'src/app/service/auth.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component';

@Component({
  selector: 'app-programa',
  templateUrl: './programa.component.html',
  styleUrls: ['./programa.component.scss']
})
export class ProgramaComponent implements OnInit {

  @ViewChild('modalPrograma') modalPrograma: UiModalComponent;

  public nome: string;
  public dataInicial: string;
  public dataFinal: string;
  public termoAceite: string;
  public arrayProgramas: any;
  public programaSelecionado: any;


  constructor(
    private router: Router,
    private ajax: AjaxService,
    public util: UtilService,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.buscar();
  }

  abrirModalNovo() {
    this.limpar();
    if (this.modalPrograma) {
      this.modalPrograma.show();
    }
  }

  fecharModal() {
    if (this.modalPrograma) {
      this.modalPrograma.hide();
    }
    this.limpar();
  }

  // Extrai a data no formato YYYY-MM-DD diretamente da string, evitando problemas de timezone
  extrairDataParaInput(dateString: string): string {
    if (!dateString) return '';
    
    // Se já está no formato YYYY-MM-DD, retorna direto
    if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return dateString;
    }
    
    // Se está no formato YYYY-MM-DDTHH:MM:SS ou similar, extrai apenas a parte da data
    if (dateString.includes('T')) {
      return dateString.split('T')[0];
    }
    
    // Se está no formato com espaço (ex: "2024-01-15 10:30:00"), extrai a parte da data
    if (dateString.includes(' ')) {
      return dateString.split(' ')[0];
    }
    
    // Tenta usar Date mas com cuidado para evitar problemas de timezone
    // Se a string parece ser uma data ISO, extrai manualmente
    const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
    }
    
    // Último recurso: tenta converter usando Date, mas pode ter problemas de timezone
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      // Usa métodos locais para manter a data como foi salva
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    
    return '';
  }

  carregarEdicao(item){
    console.log(item);
    this.limpar();
    this.programaSelecionado = item;
    this.nome = item.descricao;
    // Extrai a data diretamente sem passar por formatDateSQL para evitar problemas de timezone
    this.dataInicial = this.extrairDataParaInput(item.datA_INICIO);
    this.dataFinal = this.extrairDataParaInput(item.datA_FIM);
    this.termoAceite = item.termO_ACEITE || "";
    if (this.modalPrograma) {
      this.modalPrograma.show();
    }
  }

  buscar() {
    this.util.showLoading();
    let url = API + "Programa/Programa?STATUS=true";
    return this.ajax.get(url)
      .subscribe(response => {
        this.arrayProgramas = response.data;
        console.log(this.arrayProgramas);
        this.util.closeLoading();
      }, err => {
        debugger
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar Programa");
      });
  }

  valida() {
    if (this.nome == undefined || this.nome == "") {
      this.util.toasterShowError("Atenção", "Entre com o Nome do Programa");
      return false;
    }

    if (this.dataInicial == undefined || this.dataInicial == "") {
      this.util.toasterShowError("Atenção", "Entre com a Data Inicial");
      return false;
    }

    if (this.dataFinal == undefined || this.dataFinal == "") {
      this.util.toasterShowError("Atenção", "Entre com a Data Final");
      return false;
    }

    return true;

  }

  limpar() {
    this.nome = "";
    this.dataInicial = "";
    this.dataFinal = "";
    this.termoAceite = "";
    this.programaSelecionado = null;
  }

  // Converte data YYYY-MM-DD para formato esperado pelo backend (YYYY-MM-DDTHH:MM:SS)
  // Sem problemas de timezone, apenas adiciona a hora 00:00:00
  formatarDataParaBackend(dataString: string): string {
    if (!dataString) return '';
    
    // Se já está no formato completo, retorna
    if (dataString.includes('T')) {
      return dataString;
    }
    
    // Se está no formato YYYY-MM-DD, adiciona T00:00:00 (sem conversão de timezone)
    if (dataString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return `${dataString}T00:00:00`;
    }
    
    // Se não está no formato esperado, tenta usar formatDateSQL como fallback
    return this.util.formatDateSQL(dataString);
  }

  salvar() {

    if (this.valida()) {

      debugger
      // Converte as datas do formato YYYY-MM-DD para o formato esperado pelo backend
      // Sem problemas de timezone
      const dataInicioFormatada = this.formatarDataParaBackend(this.dataInicial);
      const dataFimFormatada = this.formatarDataParaBackend(this.dataFinal);
      
      let dados = {
        "descricao": this.nome,
        "datA_INICIO": dataInicioFormatada,
        "datA_FIM": dataFimFormatada,
        "termO_ACEITE": this.termoAceite || "",
        "STATUS": true
      }

      if(this.programaSelecionado != null)
        dados['ID_PROGRAMA'] = this.programaSelecionado.iD_PROGRAMA;

      let url = API + "Programa/Programa";
      return this.ajax.post(url, dados)
        .subscribe(response => {

          this.util.closeLoading();
          this.util.toasterShowSuccess("Atenção", "Programa Salvo com Sucesso");
          this.fecharModal();
          this.buscar();
        }, err => {
          debugger
          this.util.closeLoading();
          this.util.toasterShowError("Atenção", "Erro ao Salvar Programa");
        });

    }

  }


  desabilitar(id: string) {

    debugger
    let dados = {
      "id": id
    }
    let url = API + "Programa/Programa/Desabilitar/" + id;
    return this.ajax.post(url, dados)
      .subscribe(response => {

        this.util.closeLoading();
        this.util.toasterShowSuccess("Atenção", "Programa Desabilitado com Sucesso");
        this.nome = "";
        this.buscar();
      }, err => {
        debugger
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Salvar Programa");
      });

  }

}
